// deps
import React, { memo } from "react";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

// interface
import { CredPaymentMethod, CredPaymentGroup } from "@payment-ui/interfaces/CredPay";

// constants
import { TEXTS } from "@payment-ui/constants/index";

// test-ids
import { CRED_PAYMENT_METHOD_TEST_IDS } from "@swiggy-private/payment-test-ids";
import styles from "../Cred.v4.scss";

interface Props {
    enabled: boolean;
    selected: boolean;
    methodData: CredPaymentMethod;
    onPay: CredPaymentGroup["paymentActions"]["onPay"];
}

function PayButton(props: Props): React.ReactElement {
    const onClick = (e: React.MouseEvent): void => {
        e.stopPropagation();
        props.onPay(props.methodData);
    };

    return (
        <div className={styles.paymentMethodPayButton}>
            <SuperButton
                onClick={onClick}
                data-testid={CRED_PAYMENT_METHOD_TEST_IDS.PAY_BUTTON}
                buttonType="specialPositive"
                variant="fullwidth"
                buttonSize="medium"
            >
                {TEXTS.PAY_USING_CRED}
            </SuperButton>
        </div>
    );
}

export default memo(PayButton);
